import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

const dsn = window.SENTRY_DSN || import.meta.env.VITE_SENTRY_DSN;
const tracesSampleRate = window.SENTRY_TRACES_SAMPLE_RATE || import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ? Number(window.SENTRY_TRACES_SAMPLE_RATE || import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE) : undefined;
const replaysSessionSampleRate = window.SENTRY_REPLAYS_SESSION_SAMPLE_RATE || import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ? Number(window.SENTRY_REPLAYS_SESSION_SAMPLE_RATE || import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE) : undefined;
const replaysOnErrorSampleRate = window.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE ? Number(window.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE) : undefined;

if (dsn&&tracesSampleRate&&replaysSessionSampleRate&&replaysOnErrorSampleRate) {
  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
  
    
    tracesSampleRate,
    tracePropagationTargets: ["localhost"],
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,
  });
}